import React from 'react';
import { AlertTriangleIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { TrustRow } from '../TrustRow';
import { heroBenefits, MOCKUP_URL } from '../../data/offer';
type HeroProps = {
  ctaId: string;
};
export function Hero({
  ctaId
}: HeroProps) {
  return <header className="bg-white" data-id="element-211" data-mp="hvz7i8v8tykq">
      <div className="bg-alert px-4 py-3" data-id="element-212" data-mp="hsutykvw1qhe">
        <p className="mx-auto flex max-w-4xl items-center justify-center gap-2 text-center font-display text-[13px] font-extrabold uppercase leading-snug text-white sm:text-sm" data-id="element-213" data-mp="mutxpvvjipev">
          <AlertTriangleIcon className="hidden h-4 w-4 shrink-0 sm:block" aria-hidden="true" data-id="element-214" data-mp="vmm3vudj7cdn" />
          Stop guessing about maxillary growth. Start following a structured clinical roadmap.
        </p>
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 pb-14 pt-8 sm:pt-12 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-20" data-id="element-215" data-mp="15l1ulw8ncjmm">
        <div className="text-center lg:text-left" data-id="element-216" data-mp="1ak4pinuwx9gv">
          <h1 className="font-display text-[44px] font-black uppercase leading-[0.92] tracking-tight text-navy-950 sm:text-6xl lg:text-7xl" data-id="element-217" data-mp="9njacbineec7">
            Maxillary Growth <span className="block italic text-electric" data-id="element-218" data-mp="4ner4dqcv5ia">Blueprint™</span>
          </h1>
          <p className="mt-4 font-display text-lg font-bold leading-snug text-navy-800 sm:text-xl" data-id="element-219" data-mp="3vvj3w3ku5goh">
            The Clinical Roadmap for Maxillary Growth Assessment &amp; Dentofacial Development
          </p>
          <p className="mt-4 text-base leading-relaxed text-ink/75 sm:text-lg" data-id="element-220" data-mp="sdirmc88yp52">
            Learn how to organize maxillary growth assessments, recognize developing skeletal discrepancies, and
            strengthen your orthopedic planning framework with a visual, step-by-step clinical reference.
          </p>

          <img src={MOCKUP_URL} alt="Maxillary Growth Blueprint 6-volume collection with 5 bonus guides" className="mx-auto mt-6 w-full max-w-md lg:hidden" data-id="element-221" data-mp="ekt3o295ra5b" />
        </div>

        <img src={MOCKUP_URL} alt="Maxillary Growth Blueprint 6-volume collection with 5 bonus guides" className="hidden w-full lg:row-span-2 lg:block" data-id="element-222" data-mp="30lxhwm652x2i" />

        <div data-id="element-223" data-mp="2qw44dfmfs7vm">
          <p className="text-center text-base leading-relaxed text-ink/80 lg:text-left" data-id="element-224" data-mp="2qwdy9ealqz6l">
            Introducing <strong className="text-navy-950" data-id="element-225" data-mp="2vup4lf1ourk2">MAXILLARY GROWTH BLUEPRINT™</strong> — a comprehensive
            6-volume digital collection designed to help dental professionals navigate craniofacial growth assessment,
            skeletal development, and the foundations of dentofacial orthopedic planning.
          </p>

          <p className="mt-6 font-display text-sm font-extrabold uppercase text-navy-900" data-id="element-226" data-mp="27ybb751m7cbf">Inside, you’ll discover:</p>
          <ul className="mt-3 space-y-3" data-id="element-227" data-mp="2cwuyb8ry2u5d">
            {heroBenefits.map(item => <li key={item} className="flex gap-3 text-[15px] font-medium leading-snug text-ink sm:text-base" data-id="element-228" data-mp="676ngk2syvwd">
                <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-229" data-mp="b4gajt2pyvh1" />
                {item}
              </li>)}
          </ul>

          <div className="mt-6 flex items-center gap-3 rounded-2xl bg-navy-950 px-4 py-4 text-white" data-id="element-230" data-mp="1qoz08n7x8rcf">
            <GiftIcon className="h-8 w-8 shrink-0 text-gold" aria-hidden="true" data-id="element-231" data-mp="25dvfp5cb56n2" />
            <p className="font-display text-base font-black uppercase leading-tight sm:text-lg" data-id="element-232" data-mp="20llmngfwbqgk">
              Plus <span className="text-gold" data-id="element-233" data-mp="2ecqomp6qkuu2">5 exclusive clinical bonuses</span> included!
            </p>
          </div>

          <p className="mt-7 text-center font-display text-lg font-black uppercase leading-tight text-navy-950 sm:text-2xl lg:text-left" data-id="element-234" data-mp="2ab52sec8567q">
            Get the complete clinical blueprint for just{' '}
            <span className="whitespace-nowrap text-alert" data-id="element-235" data-mp="2jdwiiqc4uo56">$27</span>
          </p>

          <div className="mt-5" data-id="element-236" data-mp="twvh5rzd9vkl">
            <CtaButton id={ctaId} label="Yes! I want instant access" data-id="element-237" data-mp="txx3islu24hm" />
          </div>
          <div className="mt-5" data-id="element-238" data-mp="ozvgxxp77n1e">
            <TrustRow data-id="element-239" data-mp="p0wxuiswb3r1" />
          </div>
          <p className="mt-5 text-center text-xs leading-relaxed text-ink/55 lg:text-left" data-id="element-240" data-mp="qgir5ro85x0j">
            Digital educational reference for qualified dental professionals. Not a substitute for specialist training or
            patient-specific clinical judgment.
          </p>
        </div>
      </div>
    </header>;
}